export default "__VITE_ASSET__DYDkU2Lv__"